<template>
    
    <div class="section" v-if="summary.labels && user_level !== 2" v-html="summary.labels">

    </div>

    <div class="section pt-0 mt-0">
        <div class="listed-detail">
            <h3 class="text-center mt-2 custom-title">{{ pageTitle }}</h3>
        </div>
    </div>

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
        <p class="mt-2">Loading zone election report...</p>
    </div>

    <div class="listed-detail mt-0">
        <h4 class="text-center mt-0" v-if="!loading_list && member_lists.length <= 0">{{ noDataMessage }}</h4>
    </div>

    <!-- Zone Report Table -->
        <!-- State Level Election Summary -->
        <div class="section mb-2" v-if="!loading_list && member_lists.length > 0 && user_level === 1">
            <div class="card stat-box d-flex flex-row justify-content-around align-items-center p-2" style="gap: 10px;">
                <div>
                    <div class="title">NS</div>
                    <div class="value text-secondary">{{ totalNS }}</div>
                </div>
                <div>
                    <div class="title">SCH</div>
                    <div class="value text-primary">{{ totalSCH }}</div>
                </div>
                <div>
                    <div class="title">RS</div>
                    <div class="value text-warning">{{ totalRS }}</div>
                </div>
                <div>
                    <div class="title">RA</div>
                    <div class="value text-success">{{ totalRA }}</div>
                </div>
                <div>
                    <div class="title">RR</div>
                    <div class="value text-danger">{{ totalRR }}</div>
                </div>
            </div>
        </div>

        <div class="section mt-2 mb-2" v-if="!loading_list && member_lists.length > 0">
        <div class="card">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr v-if="user_level === 1">
                            <!-- State level - show summary columns -->
                            <th scope="col">{{ levelName }}</th>
                            <th scope="col">NS</th>
                            <th scope="col">SCH</th>
                            <th scope="col">RS</th>
                            <th scope="col">RA</th>
                            <th scope="col">RR</th>
                        </tr>
                        <tr v-else>
                            <!-- District level - show simple zone status -->
                            <th scope="col">{{ levelName }}</th>
                            <th scope="col" class="text-center">Election Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in member_lists" :key="item.id">
                            <!-- State level view -->
                            <template v-if="user_level === 1">
                                <td class="text-primary font-dark text-left">
                                    <router-link :to="'/reports/'+(user_level+1)+'/'+item.id+'/zone-election-report'">
                                        <strong>{{ item.name }}</strong>
                                    </router-link>
                                </td>
                                <td class="text-secondary font-dark small-text" v-html="item.not_scheduled"></td>
                                <td class="text-primary font-dark small-text" v-html="item.scheduled"></td>
                                <td class="text-warning font-dark small-text" v-html="item.report_sent"></td>
                                <td class="text-success font-dark small-text" v-html="item.report_accepted"></td>
                                <td class="text-danger font-dark small-text" v-html="item.report_rejected"></td>
                            </template>
                            
                            <!-- District level view -->
                            <template v-else>
                                <td class="text-dark font-dark text-left">
                                    <strong>{{ item.name }}</strong>
                                </td>
                                <td class="font-dark small-text" style="text-align: center !important;" :class="getElectionStatusColor(getElectionStatusText(item))">
                                    <div style="text-align: center !important;">{{ getElectionStatusText(item) }}</div>
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from "../../services/user.service";

export default {
    name: 'ZoneElectionReport',
    data() {
        return {
            permissions:[],
            loading_list: false,
            user_level: 1,
            user_level_id: null,
            member_lists: [],
            summary: {
                wisdom: '0 / 0 / 0',
                youth: '0 / 0 / 0',
                students: '0 / 0 / 0',
                women: '0 / 0 / 0',
                girls: '0 / 0 / 0',
                balavedi: '0 / 0 / 0'
            },
            series: [0, 0, 0, 0, 0, 0],
            chartOptions: {
                chart: {
                    width: '100%',
                    type: 'pie',
                },
                colors: ['#007bff', '#28a745', '#ffc107', '#dc3545', '#17a2b8', '#6c757d'],
                labels: ['Wisdom', 'Youth', 'Students', 'Women', 'Girls', 'Balavedi'],
                legend: {
                    position: 'bottom'
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 300
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            }
        };
    },
    computed: {
        // Totals for NS, SCH, RS, RA, RR (used in state level)
        totalNS() {
            return this.member_lists.reduce((sum, item) => sum + (parseInt(item.not_scheduled) || 0), 0);
        },
        totalSCH() {
            return this.member_lists.reduce((sum, item) => sum + (parseInt(item.scheduled) || 0), 0);
        },
        totalRS() {
            return this.member_lists.reduce((sum, item) => sum + (parseInt(item.report_sent) || 0), 0);
        },
        totalRA() {
            return this.member_lists.reduce((sum, item) => sum + (parseInt(item.report_accepted) || 0), 0);
        },
        totalRR() {
            return this.member_lists.reduce((sum, item) => sum + (parseInt(item.report_rejected) || 0), 0);
        },
        currentUser() {
            return this.$store.state.auth.user;
        },
        totalZoneCount() {
            return this.member_lists.length;
        },
        levelName() {
            if (this.user_level === 1) return 'District';
            if (this.user_level === 2) return 'Zone';
            return 'Zone';
        },
        pageTitle() {
            if (this.user_level === 1) return 'State - Zone wise Election Report';
            if (this.user_level === 2) return 'District - Zone wise Election Report';
            return 'Zone Election Report';
        },
        noDataMessage() {
            if (this.user_level === 1) return 'No districts found';
            if (this.user_level === 2) return 'No zones found';
            return 'No data found';
        }
    },
    created() {
        console.log('ZoneElectionReport component created!');
    },
    mounted() {
        try {
            console.log('=== ZoneElectionReport mounted ===');
            console.log('Route params:', this.$route.params);
            console.log('Full route:', this.$route);
            console.log('Current user:', this.currentUser);
            
            if (!this.currentUser) {
                console.log('No current user, redirecting to home');
                location.replace('/');
            } else {
                this.user_level = parseInt(this.$route.params.sub_level) || 1;
                // Handle the case where id might not exist in the route (for state level)
                this.user_level_id = this.$route.params.id ? parseInt(this.$route.params.id) : null;
                
                console.log('Parsed user_level:', this.user_level);
                console.log('Parsed user_level_id:', this.user_level_id);
                
                this.getZoneElectionReport();
                
                if (this.$root && this.$root.updateParent) {
                    this.$root.updateParent(this.$t('zone_election_report'));
                }
            }
        } catch (error) {
            console.error('Error in mounted hook:', error);
        }
    },
    methods: {
        getElectionStatusColor(statusText) {
            if (!statusText) return '';
            
            const lowerText = statusText.toLowerCase();
            
            if (lowerText.includes('not scheduled')) {
                return 'text-secondary'; // Gray for not scheduled
            } else if (lowerText.includes('scheduled')) {
                return 'text-primary'; // Blue for scheduled
            } else if (lowerText.includes('report sent')) {
                return 'text-warning'; // Orange/yellow for report sent
            } else if (lowerText.includes('report accepted')) {
                return 'text-success'; // Green for report accepted
            } else if (lowerText.includes('report rejected')) {
                return 'text-danger'; // Red for report rejected
            }
            
            return 'text-dark'; // Default color
        },
        
        getElectionStatusText(item) {
            if (!item) return '-';
            
            // Check which field has value 1 and return corresponding status text
            if (parseInt(item.not_scheduled) === 1) {
                return 'Not Scheduled';
            } else if (parseInt(item.scheduled) === 1) {
                return 'Scheduled';
            } else if (parseInt(item.report_sent) === 1) {
                return 'Report Sent';
            } else if (parseInt(item.report_accepted) === 1) {
                return 'Report Accepted';
            } else if (parseInt(item.report_rejected) === 1) {
                return 'Report Rejected';
            }
            
            return '-';
        },
        getZoneElectionReport() {
            console.log('=== Starting Zone Election Report API call ===');
            console.log('User Level:', this.user_level);
            console.log('User Level ID:', this.user_level_id);
            console.log('UserService available:', !!UserService);
            
            this.loading_list = true;
            
            const data = {
                user_level: this.user_level,
                report_type: 'election'
            };

            // Only include user_level_id for district level (user_level > 1)
            if (this.user_level > 1 && this.user_level_id) {
                data.user_level_id = this.user_level_id;
            }

            console.log('API Request Data:', data);

            UserService.authGetRequest('get-reports/zonal-election-report', data).then(
                (response) => {
                    console.log('API Response received:', response);
                    if (response.data.status === 'success') {
                        console.log('API Success - Data:', response.data.data);
                        this.member_lists = response.data.data.list || [];
                        this.summary = response.data.data.summary || {};
                        this.permissions = response.data.data.permissions || {};
                        
                        console.log('Member lists set:', this.member_lists);
                        console.log('Summary set:', this.summary);
                        
                        // Update chart after a small delay to ensure DOM is ready
                        this.$nextTick(() => {
                            this.updateChart();
                        });
                    } else {
                        console.error('API Error:', response.data.message);
                        this.showErrorMessage(response.data.message || 'Failed to load data');
                    }
                    this.loading_list = false;
                },
                (error) => {
                    this.loading_list = false;
                    console.error('Request Error:', error);
                    this.showErrorMessage(
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        'Something went wrong while fetching data'
                    );
                }
            ).catch((catchError) => {
                console.error('Catch block - Unexpected error:', catchError);
                this.loading_list = false;
                this.showErrorMessage('Network connection failed. Please check if the backend server is running.');
            });
        },
        
        updateChart() {
            // Extract total counts from summary for pie chart
            const totals = {
                wisdom: this.extractTotalFromSummary(this.summary.wisdom),
                youth: this.extractTotalFromSummary(this.summary.youth),
                students: this.extractTotalFromSummary(this.summary.students),
                women: this.extractTotalFromSummary(this.summary.women),
                girls: this.extractTotalFromSummary(this.summary.girls),
                balavedi: this.extractTotalFromSummary(this.summary.balavedi)
            };

            this.series = [
                totals.wisdom,
                totals.youth,
                totals.students,
                totals.women,
                totals.girls,
                totals.balavedi
            ];
        },

        extractTotalFromSummary(summaryString) {
            if (typeof summaryString === 'string') {
                const parts = summaryString.split(' / ');
                if (parts.length === 3) {
                    return parseInt(parts[2]) || 0; // Get the total count (third value)
                }
            }
            return 0;
        },
        
        viewDetails() {
            // Zonal election report is the final level - no further drill-down needed
            console.log('Zone details view not implemented - this is the final reporting level');
        },

        showErrorMessage(message) {
            // You can implement a toast notification or alert here
            if (this.$swal) {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: message,
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                });
            } else {
                alert(message);
            }
        }
    }
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.wallet-card .balance .title {
    color: #27173E;
    font-weight: 500;
    font-size: 16px;
    display: block;
    margin-bottom: 8px;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 10px 10px;
    margin-bottom: 10px;
    text-align: center;
}

.stat-box .title {
    font-size: 12px;
    color: #6c757d;
    font-weight: 500;
    margin-bottom: 5px;
}

.stat-box .value {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 2px;
    line-height: 1.2;
}

.stat-box .subtitle {
    font-size: 9px;
    color: #999;
    margin-top: 2px;
}

.wallet-card .balance {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    height: auto;
}

.left {
    margin-left: 20px;
}

.wallet-card {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 0px 16px;
    position: relative;
    z-index: 1;
    padding-bottom: 0px !important;
}

.custom-title {
    font-weight: 600;
    color: #27173E;
}

.font-dark {
    font-weight: 500;
}

.table th {
    font-size: 12px;
    text-align: center;
    background-color: #f8f9fa;
    font-weight: 600;
}

.table td {
    text-align: center;
    font-size: 12px;
    vertical-align: middle;
    padding: 8px 4px;
}

.table td.text-left {
    text-align: left;
}

.small-text {
    font-size: 10px;
    line-height: 1.2;
}

.small-text p {
    margin: 0;
    padding: 0;
}

.action-button-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.action-button-list li {
    margin-bottom: 10px;
}

.action-divider {
    height: 1px;
    background-color: #e9ecef;
    margin: 10px 0;
}

.btn-list {
    width: 100%;
    text-align: left;
    padding: 10px 15px;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    gap: 10px;
}

.btn-list:hover {
    background-color: #f8f9fa;
}

.chart-container {
    position: relative;
    width: 100%;
    max-width: 400px;
}

.right .chart-container {
    width: 100%;
}

@media (max-width: 576px) {
    .stat-box .value {
        font-size: 12px;
    }
    
    .stat-box .subtitle {
        font-size: 8px;
    }
    
    .table th,
    .table td {
        font-size: 10px;
        padding: 6px 2px;
    }
    
    .small-text {
        font-size: 9px;
    }
    
    .wallet-card .balance {
        flex-direction: column;
        align-items: center;
    }
    
    .left {
        margin-left: 0;
        text-align: center;
        margin-bottom: 15px;
    }
    
    .chart-container {
        width: 100%;
        max-width: 300px;
    }
}

@media (max-width: 768px) {
    .table-responsive {
        font-size: 10px;
    }
    
    .table th,
    .table td {
        padding: 6px 3px;
    }
}
</style>
